export default __webpack_public_path__ + "static/media/abdul.e3d5ca58.jpg";